export default __webpack_public_path__ + "static/media/IconDesc_XmasBall_Yellow.256.aa887a5d.png";